<template>
  <div>
    <div style=" font-size: 18px;padding-bottom: 20px;text-align: center;">
      {{this.provinceId ? '编辑省份' : '新增省份'}}
    </div>
    <a-form-model :label-col="{ span: 7 }" :wrapper-col="{ span: 16 }" :colon="false" :model="form.data" :rules="formRules" ref="provinceForm">
      <a-form-model-item label="发货城市" prop="cityId">
        <a-select v-model="form.data.cityId" placeholder="请选择发货城市">
          <a-select-option
            v-for="item in cityList"
            :key="item.id"
            :label="item.city"
            :value="item.id">
            {{ item.city }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="省份" prop="province">
        <a-select v-model="form.data.province" placeholder="请选择省份">
          <a-select-option
            v-for="(item,index) in provinceList"
            :key="index"
            :label="item.name"
            :value="item.name">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="所属区域" prop="areaId">
        <a-select v-model="form.data.areaId" placeholder="请选择所属区域">
          <a-select-option
            v-for="item in areaList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
    </a-form-model>
<!--    <div slot="footer" class="dialog-footer" style="text-align: center;">-->
<!--      <a-button type="primary" @click="cancel()"-->
<!--                 class="project-dialog-button">取消-->
<!--      </a-button>-->
<!--      <a-button type="primary" @click="save"-->
<!--                 class="project-dialog-button">保存-->
<!--      </a-button>-->
<!--    </div>-->
  </div>
</template>

<script>
  import {findProvince, updateProvince, saveProvince} from '../../../api/province';
  import {email, passWord} from '../../../utils/validateForm';
  import {getAreaList} from '../../../api/area';
  import {getCityList} from '../../../api/city';

  async function getProvince() {
    if (this.form.data.id) {
      const province = await findProvince(this.form.data.id);
      if (province.code === 1200) {
        this.$set(this.form.data, 'province', province.data.provinces.province);
        this.$set(this.form.data, 'areaId', province.data.provinces.areaId);
        this.$set(this.form.data, 'cityId', province.data.provinces.cityId);
      }
    } else {
      this.form.data = {};
    }
  }

  async function getAreasList() {
    this.areaList = [];
    const result = await getAreaList();
    if (result.code === 1200) {
      this.areaList = result.data.areas;
    }
  }

  async function getCitiesList() {
    this.cityList = [];
    const result = await getCityList();
    if (result.code === 1200) {
      this.cityList = result.data.cities;
    }
  }

  async function save() {
    this.$refs.provinceForm.validate(async (valid) => {
      if (valid) {
        if (this.form.data.id) {
          const resultUpdate = await updateProvince(this.form.data);
          const messagesUpdate = '更新成功';
          if (resultUpdate.code === 1200) {
            this.$message.success("更新成功");
            this.getList()
            this.form.data = {};
          } else {
            this.$message.error("更新失败");
          }
        } else {
          const resultAdd = await saveProvince(this.form.data);
          const messagesAdd = '添加成功';
          if (resultAdd.code === 1200) {
            this.$message.success("添加成功");
            this.getList()
            this.form.data = {};
          } else {
            this.$message.error("该发货地配置的省份已存在，请重新选择");
          }
        }

        // if (this.onSaveHandler) {
          // this.onSaveHandler();
        // }
      }
    });
  }

  function cancel() {
    this.$refs.provinceForm.resetFields();
    // if (this.onCancelHandler) {
      // this.onCancelHandler();
    // }
  }

  export default {
    name: 'ProvinceEdit',
    props: {
      provinceId: String,
      getList: Function
    },
    data() {
      return {
        areaList: [],
        cityList: [],
        provinceList: [
          { "name": "北京市"},{ "name": "天津市"},{ "name": "河北省"},
          { "name": "山西省"},{ "name": "内蒙古自治区"},{ "name": "辽宁省"},
          { "name": "吉林省"}, { "name": "黑龙江省"},{ "name": "上海市"},
          { "name": "江苏省"},{ "name": "浙江省"}, { "name": "安徽省"},
          { "name": "福建省"},{ "name": "江西省"}, { "name": "山东省"},
          { "name": "河南省"},{ "name": "湖北省"}, { "name": "湖南省"},
          { "name": "广东省"}, { "name": "广西壮族自治区"},   { "name": "海南省"},
          { "name": "重庆市"}, { "name": "四川省"},{ "name": "贵州省"},
          { "name": "云南省"}, { "name": "西藏自治区"}, { "name": "陕西省"},
          { "name": "甘肃省"}, { "name": "青海省"},{ "name": "宁夏回族自治区"},
          { "name": "新疆维吾尔自治区"},
        ],
        form: {
          data: {
            id: '',
            province: '北京市',
            areaId: '',
            cityId: '',
          },
        },
        formRules: {
          province: [
            {required: true, message: '请选择省份', trigger: 'blur'},
          ],
          areaId: [
            {required: true, message: '请选择所属区域', trigger: 'blur'},
          ],
          cityId: [
            {required: true, message: '请选择发货城市', trigger: 'blur'},
          ],
        },
      };
    },
    watch: {
      provinceId(val) {
        this.form.data = {};
        this.form.data.id = val;
        this.getProvince();
      },
    },
    created() {
      this.form.data.id = this.provinceId;
      this.getProvince();
      this.getAreasList();
      this.getCitiesList();
    },
    methods: {
      save,
      cancel,
      getProvince,
      getAreasList,
      getCitiesList,
    },
  };
</script>

<style scoped>

</style>
